import { render, staticRenderFns } from "./EdJsonViewer.vue?vue&type=template&id=51478a82&scoped=true&"
import script from "./EdJsonViewer.vue?vue&type=script&lang=js&"
export * from "./EdJsonViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51478a82",
  null
  
)

export default component.exports